import { render } from "./ViewBancas.vue?vue&type=template&id=21d17cc4&scoped=true"
import script from "./ViewBancas.vue?vue&type=script&lang=js"
export * from "./ViewBancas.vue?vue&type=script&lang=js"

import "./ViewBancas.vue?vue&type=style&index=0&id=21d17cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d17cc4"]])

export default __exports__